import { PoweredBy } from './../index';

export class PoweredBysByModel {
    public ModelId: number;
    public PoweredBys: PoweredBy[] = [];
}
